import { render, staticRenderFns } from "./ThemeContentPositionLookup.vue?vue&type=template&id=2ce864b6&lang=pug"
import script from "./ThemeContentPositionLookup.vue?vue&type=script&lang=js"
export * from "./ThemeContentPositionLookup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports